<div class="flex flex-col flex-1 min-h-0 dashboard-surface">
  <!-- Body: main content -->
  <div class="flex flex-1 overflow-hidden">

    <!-- Main content -->
    <div class="relative flex-1 min-w-0">

      <!-- Sync loading overlay -->
      @if (syncRunning) {
      <div
        class="absolute inset-0 z-50 flex flex-col items-center justify-center gap-4 backdrop-blur-[3px] bg-card/70 dark:bg-page/70 transition-all duration-300">
        <div
          class="flex flex-col items-center gap-3 rounded-2xl border border-line bg-card/90 dark:bg-card/80 px-10 py-8 shadow-2xl backdrop-blur-sm">
          <div class="relative flex items-center justify-center w-14 h-14">
            <div class="absolute inset-0 rounded-full border-4 border-primary/20"></div>
            <div
              class="absolute inset-0 rounded-full border-4 border-t-primary border-r-transparent border-b-transparent border-l-transparent animate-spin">
            </div>
            <i class="pi pi-sync text-primary text-lg"></i>
          </div>
          <div class="text-center">
            <p class="text-sm font-semibold text-ink">Syncing data…</p>
            <p class="text-xs text-dim mt-0.5">Fetching latest records from your integrations</p>
          </div>
        </div>
      </div>
      }

      @if ((dataLoading || comparisonLoading) && !syncRunning) {
      <div
        class="absolute inset-0 z-40 flex items-center justify-center bg-page/70 backdrop-blur-[3px] transition-opacity dark:bg-page/75"
        role="status"
        aria-live="polite"
        aria-label="Updating dashboard data"
      >
        <div class="relative flex h-16 w-16 items-center justify-center rounded-2xl border border-primary/30 bg-card/95 text-primary shadow-2xl">
          <span class="absolute inset-2 animate-spin rounded-xl border-[3px] border-primary/15 border-t-primary border-r-primary" aria-hidden="true"></span>
          <i class="pi pi-chart-line text-lg" aria-hidden="true"></i>
        </div>
      </div>
      }

      <div class="h-full responsive-page-padding" [ngClass]="pageContentClass">

        <!-- KPI cards: one row -->
        <div class="dashboard-kpi-grid grid @container/kpis" [ngClass]="kpiGridClass">
          @for (kpi of kpiSlots; track $index) {
          <app-kpi-card
            [kpi]="kpi"
            [colorIndex]="$index"
            [showComparison]="pageVariant === 'overview'"
            [showAsTableEnabled]="isKpiCardInteractive(kpi)"
            [actionLabel]="kpiCardActionLabel(kpi)"
            (showAsTable)="onKpiCardAction($event)"
          />
          }
        </div>

        @if (pageVariant === 'team-performance') {
        <div class="dashboard-split-grid grid grid-cols-1 lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] gap-4 @container/team-performance">
          <app-chart-card class="block min-w-0 h-auto lg:h-[420px]" title="Top 10 Consultants by Gross Profit"
            [breadcrumb]="selectedRecruiterName !== 'all' ? [selectedRecruiterName] : []"
            [filtered]="selectedRecruiterName !== 'all'"
            (breadcrumbClick)="clearSelectedConsultant()"
            [hideDrillUp]="true" [hideDrillDown]="true" [hideNextLevel]="true"
            [hideExpandAll]="true" [hideOpenDetails]="true">
            <div class="flex h-full w-full min-h-[300px] lg:min-h-0 flex-col">
              @if (evertimeTopConsultants.length > 0) {
              <div class="relative flex-1 min-h-0 w-full overflow-hidden">
                <div class="absolute inset-0">
                  <app-evertime-gp-bar-chart
                    [rows]="evertimeTopConsultants"
                    [selectedName]="selectedRecruiterName !== 'all' ? selectedRecruiterName : null"
                    tone="accent"
                    (barClick)="selectTopGrossProfitConsultant($event)"
                  />
                </div>
              </div>
              } @else {
              <div class="relative flex-1 min-h-[300px] flex flex-col items-center justify-center gap-3 animate-pulse select-none">
                <div class="w-full space-y-3 px-4">
                  <div class="h-5 bg-slate-100 dark:bg-line rounded" style="width:82%"></div>
                  <div class="h-5 bg-slate-100 dark:bg-line rounded" style="width:68%"></div>
                  <div class="h-5 bg-slate-100 dark:bg-line rounded" style="width:74%"></div>
                  <div class="h-5 bg-slate-100 dark:bg-line rounded" style="width:55%"></div>
                  <div class="h-5 bg-slate-100 dark:bg-line rounded" style="width:61%"></div>
                </div>
              </div>
              }
            </div>
          </app-chart-card>

          <app-chart-card class="block min-w-0 h-auto lg:h-[420px]" title="Contractors Worked"
            [breadcrumb]="[]" [filtered]="false" [hideDrillUp]="true" [hideDrillDown]="true" [hideNextLevel]="true"
            [hideExpandAll]="true" [hideOpenDetails]="true">
            <div class="flex h-full w-full min-h-[300px] lg:min-h-0 flex-col">
              @if (teamContractorsWorkedTrend.length > 0) {
              <div class="relative flex-1 min-h-0 w-full overflow-visible">
                <div class="absolute inset-0">
                  <app-contractors-worked-trend-chart
                    [data]="teamContractorsWorkedTrend"
                    (pointClick)="openContractorsWorkedMonthTable($event)"
                  />
                </div>
              </div>
              } @else {
              <div class="relative flex-1 min-h-[300px] flex flex-col items-center justify-center gap-3 animate-pulse select-none">
                <div class="w-full flex items-end gap-2 px-4 h-32">
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:42%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:56%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:48%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:68%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:62%"></div>
                </div>
                <div class="h-3 bg-slate-100 dark:bg-line rounded w-28"></div>
              </div>
              }
            </div>
          </app-chart-card>
        </div>

        <app-chart-card class="block min-w-0 h-auto lg:h-[650px]" title="Consultant Leaderboard"
          [breadcrumb]="[]"
          [filtered]="false"
          [hideDrillUp]="true" [hideDrillDown]="true"
          [hideNextLevel]="true" [hideExpandAll]="true" [hideOpenDetails]="true">
          <div class="dashboard-table-frame flex flex-1 min-h-0 overflow-hidden">
            <app-data-table
              [columns]="teamLeaderboardColumns"
              [rows]="teamLeaderboardRows"
              [pageSize]="10"
              [maxVisibleRows]="10"
              [showPaginator]="false"
              (rowClick)="openConsultantDialog($event)"
              recordName="Consultants"
            />
          </div>
        </app-chart-card>
        }

        @if (pageVariant === 'clients') {
        <div class="dashboard-split-grid grid grid-cols-1 lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] gap-4 @container/clients">
          <app-chart-card class="block min-w-0 h-auto lg:h-[420px]" title="Top 10 Clients by Gross Profit"
            [breadcrumb]="[]" [filtered]="selectedPerformanceClientName !== 'all'"
            (breadcrumbClick)="clearSelectedPerformanceClient()"
            [hideDrillUp]="true" [hideDrillDown]="true"
            [hideNextLevel]="true" [hideExpandAll]="true" [hideOpenDetails]="true">
            <div class="flex h-full w-full min-h-[300px] lg:min-h-0 flex-col">
              @if (clientsTabTopClients.length > 0) {
              <div class="relative flex-1 min-h-0 w-full overflow-hidden">
                <div class="absolute inset-0">
                  <app-evertime-gp-bar-chart
                    [rows]="clientsTabTopClients"
                    [selectedName]="selectedPerformanceClientName !== 'all' ? selectedPerformanceClientName : null"
                    tone="primary"
                    (barClick)="selectTopGrossProfitClient($event)"
                  />
                </div>
              </div>
              } @else {
              <div class="relative flex-1 min-h-[300px] flex flex-col items-center justify-center gap-3 animate-pulse select-none">
                <div class="w-full space-y-3 px-4">
                  <div class="h-5 bg-slate-100 dark:bg-line rounded" style="width:86%"></div>
                  <div class="h-5 bg-slate-100 dark:bg-line rounded" style="width:72%"></div>
                  <div class="h-5 bg-slate-100 dark:bg-line rounded" style="width:64%"></div>
                  <div class="h-5 bg-slate-100 dark:bg-line rounded" style="width:58%"></div>
                </div>
              </div>
              }
            </div>
          </app-chart-card>

          <app-chart-card class="block min-w-0 h-auto lg:h-[420px]" [title]="clientRightChartTitle"
            [breadcrumb]="[]" [filtered]="clientRightChartFiltered" [hideDrillUp]="true" [hideDrillDown]="true"
            [hideNextLevel]="true" [hideExpandAll]="true" [hideOpenDetails]="true">
            <div class="flex h-full w-full min-h-[300px] lg:min-h-0 flex-col">
              @if (selectedClientName === 'all' && clientRevenueConcentrationData.length > 0) {
              <div class="relative flex-1 min-h-0 w-full overflow-visible">
                <div class="absolute inset-[10px_0_0_0]">
                  <app-evertime-donut-chart [data]="clientRevenueConcentrationData" />
                </div>
              </div>
              } @else if (selectedClientName !== 'all' && selectedClientRevenueHistory.length > 0) {
              <div class="relative flex-1 min-h-0 w-full overflow-hidden">
                <div class="absolute inset-0">
                  <app-client-revenue-history-chart [data]="selectedClientRevenueHistory" />
                </div>
              </div>
              } @else {
              <div class="relative flex-1 min-h-[300px] flex flex-col items-center justify-center gap-3 animate-pulse select-none">
                <div class="w-full flex items-end gap-2 px-4 h-32">
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:48%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:70%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:56%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:62%"></div>
                </div>
                <div class="h-3 bg-slate-100 dark:bg-line rounded w-28"></div>
              </div>
              }
            </div>
          </app-chart-card>
        </div>

        <app-chart-card class="block min-w-0 h-auto lg:h-[650px]" title="Client Performance"
          [breadcrumb]="selectedPerformanceClientName !== 'all' ? [selectedPerformanceClientName] : []"
          [filtered]="false"
          [hideDrillUp]="true" [hideDrillDown]="true"
          [hideNextLevel]="true" [hideExpandAll]="true" [hideOpenDetails]="true">
          <div class="dashboard-table-frame flex flex-1 min-h-0 overflow-hidden">
            <app-data-table
              [columns]="clientPerformanceColumns"
              [rows]="clientPerformanceRows"
              [pageSize]="10"
              [pageSizeOptions]="[5, 10, 25, 50]"
              [showPageSizeSelector]="true"
              [showAllPageSizeOption]="true"
              [maxVisibleRows]="10"
              [filterFields]="['client']"
              [showExport]="true"
              [exportScope]="'filtered'"
              tableMinWidth="79.5rem"
              exportFileName="Client Performance"
              recordName="Clients"
            />
          </div>
        </app-chart-card>
        }

        @if (showDashboardCharts) {
         <!-- Charts row -->
        <div class="dashboard-main-chart-row grid gap-4 @container/charts"
          [class.revenue-chart-row]="pageVariant === 'revenue'"
          [class.cash-chart-row]="pageVariant === 'cash-credit-control'"
          [ngClass]="pageVariant === 'revenue' ? 'grid-cols-1 lg:grid-cols-2' : pageVariant === 'cash-credit-control' ? 'grid-cols-1 lg:grid-cols-2' : 'grid-cols-1'">

          @if (pageVariant === 'cash-credit-control') {
          <app-chart-card class="block min-w-0 h-auto lg:h-[360px] cash-chart-card" title="Aged Debt As At"
            [breadcrumb]="[]" [filtered]="selectedAgedDebtBucket !== null"
            (breadcrumbClick)="clearAgedDebtBucketFilter()"
            [hideDrillUp]="true" [hideDrillDown]="true" [hideNextLevel]="true"
            [hideExpandAll]="true" [hideOpenDetails]="true">
            <div chartCardTitleActions class="inline-flex items-center text-[10px] font-bold uppercase tracking-wide text-muted">
              <span>{{ agedDebtAsAtLabel }}</span>
            </div>
            <div class="flex h-full w-full min-h-[260px] lg:min-h-0 flex-col cash-chart-body">
              @if (currentAgedDebtSummary) {
              <div class="grid grid-cols-2 gap-2 border-b border-line px-3 py-2">
                <div class="min-w-0">
                  <div class="text-[9px] font-bold uppercase tracking-wide text-muted">Total Outstanding</div>
                  <div class="truncate text-xs font-extrabold text-ink">{{ currentAgedDebtSummary.totalOutstanding | currency:'GBP':'symbol':'1.0-0' }}</div>
                </div>
                <div class="min-w-0">
                  <div class="text-[9px] font-bold uppercase tracking-wide text-muted">Unallocated Cash</div>
                  <div class="flex items-center gap-2">
                    <span class="truncate text-xs font-extrabold text-ink">{{ currentAgedDebtSummary.unallocatedCash | currency:'GBP':'symbol':'1.0-0' }}</span>
                    <button
                      type="button"
                      class="inline-flex shrink-0 items-center justify-center bg-transparent p-0.5 text-primary transition-opacity hover:opacity-70"
                      aria-label="View unallocated cash drill down"
                      title="Drill down"
                      (click)="unallocatedCashDetailsVisible = true"
                    >
                      <i class="pi pi-external-link text-xs" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
              }
              @if (!currentAgedDebtLoading && agedDebtBuckets.length > 0) {
              <div class="relative flex-1 min-h-0 w-full overflow-hidden">
                <div class="absolute inset-0">
                  <app-aged-debt-bucket-chart
                    [data]="agedDebtBuckets"
                    [selectedBucket]="selectedAgedDebtBucket"
                    (bucketSelect)="selectAgedDebtBucket($event)"
                  />
                </div>
              </div>
              } @else if (currentAgedDebtLoading) {
              <div class="relative flex-1 min-h-[260px] flex flex-col items-center justify-center gap-3 animate-pulse select-none">
                <div class="w-full space-y-3 px-4">
                  <div class="h-6 bg-slate-100 dark:bg-line rounded" style="width:72%"></div>
                  <div class="h-6 bg-slate-100 dark:bg-line rounded" style="width:58%"></div>
                  <div class="h-6 bg-slate-100 dark:bg-line rounded" style="width:44%"></div>
                  <div class="h-6 bg-slate-100 dark:bg-line rounded" style="width:88%"></div>
                </div>
              </div>
              } @else {
              <div class="relative flex-1 min-h-[260px] flex flex-col items-center justify-center gap-2 select-none text-muted">
                <i class="pi pi-chart-bar text-2xl" aria-hidden="true"></i>
                <span class="text-xs font-semibold">Awaiting aged debt data</span>
              </div>
              }
            </div>
          </app-chart-card>

          <p-dialog
            class="hidden"
            [(visible)]="unallocatedCashDetailsVisible"
            appendTo="body"
            [modal]="true"
            transitionOptions="0ms"
            [style]="{ width: 'calc(100vw - 16px)', 'max-width': 'calc(100vw - 16px)', 'max-height': 'calc(100dvh - 16px)' }"
            [breakpoints]="{ '960px': 'calc(100vw - 8px)' }"
            [contentStyle]="{ height: 'auto', 'max-height': 'calc(100dvh - 5rem)', overflow: 'auto' }"
            [header]="'Unallocated Cash Breakdown - ' + agedDebtAsAtLabel"
            [draggable]="false"
            [resizable]="false"
          >
            <div class="min-h-0 overflow-auto rounded-xl border border-line bg-card">
              <app-data-table
                [columns]="unallocatedCashColumns"
                [rows]="unallocatedCashRows"
                [statusField]="'documentStatus'"
                [filterFields]="['clientName', 'reference', 'bankReference']"
                [showPaginator]="true"
                [showPageSizeSelector]="true"
                [showAllPageSizeOption]="true"
                [pageSize]="10"
                [pageSizeOptions]="[10, 25, 50]"
                [maxVisibleRows]="10"
                [compact]="true"
                [showExport]="true"
                [exportScope]="'filtered'"
                exportFileName="Unallocated Cash Breakdown"
                recordName="Unallocated cash receipts"
              />
            </div>
          </p-dialog>

          <app-chart-card class="block min-w-0 h-auto lg:h-[360px] cash-chart-card dso-trend-card" title="DSO by Month"
            [breadcrumb]="[]" [filtered]="false" [hideDrillUp]="true" [hideDrillDown]="true" [hideNextLevel]="true"
            [hideExpandAll]="true" [hideOpenDetails]="true">
            <div class="flex h-full w-full min-h-[260px] lg:min-h-0 flex-col cash-chart-body">
              @if (!dsoByMonthLoading && dsoTrend.length > 0) {
              <div class="relative flex-1 min-h-0 w-full overflow-visible">
                <div class="absolute inset-0">
                  <app-dso-trend-chart [data]="dsoTrend" [targetDays]="dsoTargetDays" />
                </div>
              </div>
              } @else if (dsoByMonthLoading) {
              <div class="relative flex-1 min-h-[260px] flex flex-col items-center justify-center gap-3 animate-pulse select-none">
                <div class="h-32 w-full px-5">
                  <div class="h-full rounded bg-slate-100 dark:bg-line"></div>
                </div>
                <div class="h-3 w-28 rounded bg-slate-100 dark:bg-line"></div>
              </div>
              } @else {
              <div class="relative flex-1 min-h-[260px] flex flex-col items-center justify-center gap-2 select-none text-muted">
                <i class="pi pi-chart-line text-2xl" aria-hidden="true"></i>
                <span class="text-xs font-semibold">Awaiting DSO data</span>
              </div>
              }
            </div>
          </app-chart-card>

          @if (false) {
          <app-chart-card class="block min-w-0 h-auto lg:h-[360px] cash-chart-card liabilities-card" title="Liabilities"
            [breadcrumb]="[]" [filtered]="false" [hideDrillUp]="true" [hideDrillDown]="true" [hideNextLevel]="true"
            [hideExpandAll]="true" [hideOpenDetails]="true">
            <div chartCardActions class="liabilities-heading-actions">
              <span class="text-[10px] font-bold uppercase tracking-wide text-muted">Month</span>
              <p-datepicker
                [(ngModel)]="selectedLiabilitiesMonth"
                (ngModelChange)="onLiabilitiesMonthChange($event)"
                view="month"
                dateFormat="MM yy"
                [maxDate]="liabilitiesMaxMonth"
                [readonlyInput]="true"
                [showIcon]="true"
                iconDisplay="input"
                icon="pi pi-calendar"
                appendTo="body"
                class="w-40 shrink-0"
                [style]="{ width: '160px' }"
                inputStyleClass="h-7 w-40 rounded-md border border-line bg-page py-0 pl-2 pr-7 text-[11px] font-semibold text-ink outline-none focus:border-primary cursor-pointer"
                ariaLabel="Select liabilities month"
              />
              @if (selectedLiabilitiesMonth) {
                <button type="button" class="flex h-7 w-7 items-center justify-center rounded-md border border-line bg-card text-muted hover:text-ink" (click)="clearLiabilitiesMonth()" aria-label="Clear liabilities month" title="Clear month">
                  <i class="pi pi-times text-[10px]"></i>
                </button>
              }
            </div>
            <div class="liabilities-panel">
              <p class="liabilities-date">
                @if (selectedLiabilitiesMonth) {
                  As on {{ liabilitiesAsOf }}
                  @if (isLiabilitiesMonthComplete) { · Xero month end }
                } @else {
                  Select a month to view liabilities
                }
              </p>
              @if (liabilitiesLoading) {
                <div class="liabilities-status">Loading…</div>
              } @else if (liabilitiesError) {
                <div class="liabilities-status liabilities-error">Data unavailable</div>
              } @else {
              <div class="liabilities-content">
                <div class="liabilities-details">
                  <div class="liabilities-table-shell">
                    <table class="liabilities-table">
                      <thead>
                        <tr>
                          <th scope="col">Liability</th>
                          <th scope="col">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (liability of liabilities; track liability.label) {
                        <tr>
                          <td>
                            <span class="liabilities-label">
                              {{ liability.label }}
                            </span>
                          </td>
                          <td>{{ liability.amount | currency:'GBP':'symbol':'1.2-2' }}</td>
                        </tr>
                        }
                      </tbody>
                      <tfoot>
                        <tr>
                          <th scope="row">Total Liabilities</th>
                          <td>{{ liabilitiesTotal | currency:'GBP':'symbol':'1.2-2' }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              }
            </div>
          </app-chart-card>
          }
          } @else if (pageVariant === 'revenue') {
          <app-chart-card class="block min-w-0 h-auto lg:h-[470px] revenue-chart-card" title="Revenue Per Month"
            [breadcrumb]="[]" [filtered]="false" [hideDrillUp]="true" [hideDrillDown]="true" [hideNextLevel]="true"
            [hideExpandAll]="true" [hideOpenDetails]="true">
            <div class="flex h-full w-full min-h-[300px] lg:min-h-0 flex-col revenue-chart-body">
              @if (evertimeMonthlyRevenue && evertimeMonthlyRevenue.length > 0) {
              <div class="relative flex-1 min-h-0 w-full overflow-visible">
                <div class="absolute inset-0">
                  <app-placement-revenue-chart [data]="evertimeMonthlyRevenue" />
                </div>
              </div>
              } @else {
              <div class="relative flex-1 min-h-[300px] flex flex-col items-center justify-center gap-3 animate-pulse select-none">
                <div class="w-full flex items-end gap-2 px-4 h-32">
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:60%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:90%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:45%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:75%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:55%"></div>
                </div>
                <div class="h-3 bg-slate-100 dark:bg-line rounded w-28"></div>
              </div>
              }
            </div>
          </app-chart-card>

          <app-chart-card class="block min-w-0 h-auto lg:h-[470px] revenue-chart-card" title="GPM By Month"
            [breadcrumb]="[]" [filtered]="false" [hideDrillUp]="true" [hideDrillDown]="true" [hideNextLevel]="true"
            [hideExpandAll]="true" [hideOpenDetails]="true">
            <div class="flex h-full w-full min-h-[300px] lg:min-h-0 flex-col revenue-chart-body">
              <div class="relative flex-1 min-h-0 w-full overflow-visible">
                <div class="absolute inset-0">
                  <app-gp-margin-trend-chart [data]="evertimeGpMarginTrendData" />
                </div>
              </div>
            </div>
          </app-chart-card>
          } @else {
          <!-- Revenue by Month -->
          <app-chart-card id="overview-relative-graph" class="block min-w-0 h-auto lg:h-[410px]" [title]="chart1Title"
            [hideHeader]="pageVariant === 'overview'"
            [breadcrumb]="chart1Breadcrumb" (breadcrumbClick)="chart1BreadcrumbClick.emit($event)"
            [filtered]="chart1Filtered" [hideDrillUp]="true" [hideDrillDown]="true" [hideNextLevel]="true"
            [hideExpandAll]="true" [hideOpenDetails]="true">
            <div class="flex h-full w-full min-h-[300px] lg:min-h-0 flex-col">
              <!-- Inner Plot Surface -->
              <div class="relative flex-1 min-h-[240px] lg:min-h-0 w-full overflow-hidden">
                @if (pageVariant === 'overview' && overviewSelectionRange) {
                <button
                  type="button"
                  class="absolute right-3 top-2 z-10 rounded-md border border-line bg-card/95 px-2.5 py-1 text-xs font-semibold text-muted shadow-sm transition hover:border-primary/40 hover:text-primary"
                  (click)="overviewSelectionClear.emit()"
                  aria-label="Clear month filter"
                >
                  Clear filter
                </button>
                }
                @if (financialOverviewData) {
                <div class="absolute inset-0">
                  <app-financial-overview-chart
                    [data]="financialOverviewData"
                    [comparisonData]="comparisonFinancialOverviewData"
                    [metric]="activeChart1Metric"
                    [selectionRange]="pageVariant === 'overview' ? overviewSelectionRange : null"
                    (chartClick)="onFinancialOverviewChartClick($event)"
                    (chartContextMenu)="openOverviewMonthContextMenu($event)"
                    (selectionRangeChange)="overviewSelectionRangeChange.emit($event)"
                  />
                </div>
                } @else {
                <div class="absolute inset-0 flex flex-col items-center justify-center gap-3 animate-pulse select-none">
                  <div class="w-full flex items-end gap-2 px-4 h-32">
                    <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:60%"></div>
                    <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:90%"></div>
                    <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:45%"></div>
                    <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:75%"></div>
                    <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:55%"></div>
                  </div>
                  <div class="h-3 bg-slate-100 dark:bg-line rounded w-28"></div>
                </div>
                }
              </div>
            </div>
          </app-chart-card>
          }

        </div>
        }

        @if (pageVariant === 'overview') {
        <app-chart-card class="overview-progression-card block min-w-0 h-auto lg:h-[360px]" title="Progression of Financial Metrics"
          [breadcrumb]="[]" [filtered]="false" [hideDrillUp]="true" [hideDrillDown]="true"
          [hideNextLevel]="true" [hideExpandAll]="true" [hideOpenDetails]="true">
          <div class="overview-progression-body relative h-full min-h-[240px] lg:min-h-0 w-full overflow-hidden">
            <app-kpi-waterfall-chart
              [metrics]="progressionOfFinancialMetrics"
              [comparisonMetrics]="comparisonProgressionOfFinancialMetrics"
              (metricClick)="openProgressionMetricTable($event)"
            />
          </div>
        </app-chart-card>
        }

        @if (pageVariant === 'cash-credit-control') {
        <app-chart-card class="block min-w-0 h-auto lg:h-[360px] cash-table-card" title="Client Chase List"
          [style.--client-chase-card-height]="clientChaseCardHeight + 'px'"
          [breadcrumb]="[]"
          [filtered]="false"
          [hideDrillUp]="true" [hideDrillDown]="true" [hideNextLevel]="true"
          [hideExpandAll]="true" [hideOpenDetails]="true">
          <div chartCardTitleActions class="relative w-56 max-w-full">
            <i class="pi pi-search pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-xs text-dim" aria-hidden="true"></i>
            <input
              type="search"
              class="h-8 w-full rounded-md border border-line bg-card pl-8 pr-3 text-xs text-ink outline-none transition placeholder:text-dim focus:border-primary focus:ring-1 focus:ring-primary/20"
              [(ngModel)]="clientChaseNameSearch"
              placeholder="Search client name"
              aria-label="Search Client Chase List by client name"
            />
          </div>
          <div chartCardActions class="flex items-center gap-2">
            <button
              type="button"
              class="inline-flex h-7 shrink-0 items-center gap-1.5 rounded-md border border-line bg-card px-2.5 text-[11px] font-semibold text-dim shadow-sm transition-colors hover:border-primary hover:bg-primary-bg hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer"
              [disabled]="!filteredCreditControlClients || filteredCreditControlClients.length === 0"
              (click)="clientChaseTable.exportExcel()"
              aria-label="Export Client Chase List to Excel"
              title="Export to Excel"
            >
              <i class="pi pi-download text-[10px]"></i>
              <span>Export</span>
            </button>
          </div>
          <div class="flex h-full min-h-0 flex-col">
            <div class="dashboard-table-frame flex flex-1 min-h-0 overflow-hidden">
              <app-data-table
                #clientChaseTable
                [columns]="visibleCreditControlColumns"
                [rows]="filteredCreditControlClients"
                [pageSize]="5"
                [pageSizeOptions]="[5, 10, 25, 50]"
                [showPageSizeSelector]="true"
                (pageSizeSelectionChange)="onClientChasePageSizeChange($event)"
                [maxVisibleRows]="5"
                [exportScope]="'filtered'"
                exportFileName="Client Chase List"
                recordName="Clients"
                (rowClick)="openClientChaseDetails($event)"
              />
            </div>
          </div>
        </app-chart-card>

        <p-dialog
          [visible]="selectedClientChaseClient !== null"
          appendTo="body"
          (visibleChange)="!$event && closeClientChaseDetails()"
          [modal]="true"
          transitionOptions="0ms"
          [style]="{ width: 'calc(100vw - 16px)', 'max-width': 'calc(100vw - 16px)', 'max-height': 'calc(100dvh - 16px)' }"
          [breakpoints]="{ '960px': 'calc(100vw - 8px)' }"
          [contentStyle]="{ height: 'auto', 'max-height': 'calc(100dvh - 5rem)', overflow: 'auto' }"
          [header]="selectedClientChaseClient ? 'Client Chase Details - ' + selectedClientChaseClient.clientName : 'Client Chase Details'"
          [draggable]="false"
          [resizable]="false"
        >
          @if (selectedClientChaseClient) {
          <div class="mb-3 grid grid-cols-2 gap-2 md:grid-cols-3 xl:grid-cols-6">
            <div class="rounded-lg border border-line bg-page px-3 py-2">
              <div class="text-[9px] font-bold uppercase tracking-wide text-muted">Outstanding Invoices</div>
              <div class="text-sm font-extrabold text-ink">{{ selectedClientChaseClient.outstandingInvoiceCount ?? 0 }}</div>
            </div>
            <div class="rounded-lg border border-line bg-page px-3 py-2">
              <div class="text-[9px] font-bold uppercase tracking-wide text-muted">Total Outstanding</div>
              <div class="text-sm font-extrabold text-ink">{{ selectedClientChaseClient.totalOutstanding | currency:'GBP':'symbol':'1.0-0' }}</div>
            </div>
            <div class="rounded-lg border border-line bg-page px-3 py-2">
              <div class="text-[9px] font-bold uppercase tracking-wide text-muted">0 to 30</div>
              <div class="text-sm font-extrabold text-ink">{{ selectedClientChaseClient.bucket0To30 | currency:'GBP':'symbol':'1.0-0' }}</div>
            </div>
            <div class="rounded-lg border border-line bg-page px-3 py-2">
              <div class="text-[9px] font-bold uppercase tracking-wide text-muted">31 to 60</div>
              <div class="text-sm font-extrabold text-ink">{{ selectedClientChaseClient.bucket31To60 | currency:'GBP':'symbol':'1.0-0' }}</div>
            </div>
            <div class="rounded-lg border border-line bg-page px-3 py-2">
              <div class="text-[9px] font-bold uppercase tracking-wide text-muted">61 to 90</div>
              <div class="text-sm font-extrabold text-ink">{{ selectedClientChaseClient.bucket61To90 | currency:'GBP':'symbol':'1.0-0' }}</div>
            </div>
            <div class="rounded-lg border border-line bg-page px-3 py-2">
              <div class="text-[9px] font-bold uppercase tracking-wide text-muted">90+</div>
              <div class="text-sm font-extrabold text-ink">{{ selectedClientChaseClient.bucket90Plus | currency:'GBP':'symbol':'1.0-0' }}</div>
            </div>
          </div>
          }
          <div class="min-h-0 overflow-auto rounded-xl border border-line bg-card">
            @if (clientChaseDetailsLoading) {
            <div class="flex min-h-64 flex-col items-center justify-center gap-3" aria-label="Loading client chase details">
              <i class="pi pi-spin pi-spinner text-2xl text-primary" aria-hidden="true"></i>
              <span class="text-xs font-semibold text-muted">Loading client chase details</span>
            </div>
            } @else {
            <app-data-table
              [columns]="clientChaseDrillDownColumns"
              [rows]="selectedClientChaseDetailRows"
              [statusField]="'invoiceStatus'"
              [filterFields]="['invoiceNumber', 'invoiceDate', 'dueDate', 'invoiceDetails', 'itemType']"
              [optionFilterFields]="['itemType']"
              [showPaginator]="true"
              [showPageSizeSelector]="true"
              [showAllPageSizeOption]="true"
              [pageSize]="8"
              [pageSizeOptions]="[8, 10, 25, 50]"
              [maxVisibleRows]="8"
              [compact]="true"
              [showExport]="true"
              [exportScope]="'filtered'"
              [exportFileName]="clientChaseExportFileName"
              [sortableFields]="['invoiceNumber', 'invoiceDate', 'dueDate', 'invoiceStatus', 'itemType', 'invoiceTotal', 'creditNotesApplied', 'overpaymentsApplied', 'prepaymentsApplied', 'outstandingAmount', 'unallocatedCashAmount', 'invoiceAgeDays', 'daysOverdue']"
              recordName="Client chase invoices"
            >
              <ng-template #toolbarEndTemplate>
                <span class="text-[10px] font-bold uppercase tracking-wide text-muted">Invoice Age</span>
                <div class="inline-flex shrink-0 overflow-hidden rounded-md border border-line bg-page p-0.5" role="group" aria-label="Filter invoices by invoice age">
                  @for (bucket of clientChaseAgeBuckets; track bucket.value) {
                  <button
                    type="button"
                    class="rounded px-2 py-1 text-[10px] font-semibold transition-colors"
                    [class.text-white]="selectedClientChaseAgeBucket === bucket.value"
                    [class.bg-primary]="selectedClientChaseAgeBucket === bucket.value && !clientChaseAgeBucketColor(bucket.value)"
                    [class.text-dim]="selectedClientChaseAgeBucket !== bucket.value"
                    [class.hover:bg-primary-bg]="selectedClientChaseAgeBucket !== bucket.value"
                    [style.background-color]="selectedClientChaseAgeBucket === bucket.value ? clientChaseAgeBucketColor(bucket.value) : null"
                    [attr.aria-pressed]="selectedClientChaseAgeBucket === bucket.value"
                    (click)="selectClientChaseAgeBucket(bucket.value)"
                  >{{ bucket.label }}</button>
                  }
                </div>
              </ng-template>
            </app-data-table>
            }
          </div>
        </p-dialog>
        }

        @if (pageVariant === 'revenue') {
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 @container/revenue-margin-row revenue-chart-row">
          <app-chart-card class="block min-w-0 h-auto lg:h-[420px] revenue-chart-card" title="Margin Comparison"
            [breadcrumb]="[]" [filtered]="false" [hideDrillUp]="true" [hideDrillDown]="true" [hideNextLevel]="true"
            [hideExpandAll]="true" [hideOpenDetails]="true">
            <div class="flex h-full w-full min-h-[300px] lg:min-h-0 flex-col revenue-chart-body">
              @if (marginComparisonData.length > 0) {
              <div class="relative flex-1 min-h-0 w-full overflow-visible">
                <div class="absolute inset-0">
                  <app-margin-comparison-chart [data]="marginComparisonData" />
                </div>
              </div>
              } @else {
              <div class="relative flex-1 min-h-[300px] flex flex-col items-center justify-center gap-3 animate-pulse select-none">
                <div class="w-full flex items-end gap-2 px-4 h-32">
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:72%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:60%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:48%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:66%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:52%"></div>
                </div>
                <div class="h-3 bg-slate-100 dark:bg-line rounded w-28"></div>
              </div>
              }
            </div>
          </app-chart-card>

          <app-chart-card class="block min-w-0 h-auto lg:h-[420px] revenue-chart-card" title="Administrative Cost % of Revenue"
            [breadcrumb]="[]" [filtered]="false" [hideDrillUp]="true" [hideDrillDown]="true" [hideNextLevel]="true"
            [hideExpandAll]="true" [hideOpenDetails]="true">
            <div class="flex h-full w-full min-h-[300px] lg:min-h-0 flex-col revenue-chart-body">
              @if (operatingCostPercentData.length > 0) {
              <div class="relative flex-1 min-h-0 w-full overflow-visible">
                <div class="absolute inset-0">
                  <app-operating-cost-ratio-chart [data]="operatingCostPercentData" />
                </div>
              </div>
              } @else {
              <div class="relative flex-1 min-h-[300px] flex flex-col items-center justify-center gap-3 animate-pulse select-none">
                <div class="w-full flex items-end gap-2 px-4 h-32">
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:42%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:52%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:58%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:68%"></div>
                  <div class="flex-1 bg-slate-100 dark:bg-line rounded-t" style="height:62%"></div>
                </div>
                <div class="h-3 bg-slate-100 dark:bg-line rounded w-28"></div>
              </div>
              }
            </div>
          </app-chart-card>
        </div>
        }

      </div><!-- end inner scroll -->

    </div><!-- end relative wrapper -->

  </div><!-- end body flex -->

  <!-- Slicers panel -->
  <app-slicers-panel [(visible)]="slicersPanelVisible" />

  <!-- Invoice detail dialog -->
  <app-invoice-dialog [(visible)]="invoiceDialogVisible" [invoice]="selectedInvoice" />

  <p-dialog
    [visible]="selectedProgressionTableMetric !== null"
    (visibleChange)="!$event && closeProgressionMetricTableDialog()"
    [modal]="true"
    [showHeader]="false"
    styleClass="table-dialog--headerless"
    transitionOptions="0ms"
    [style]="selectedProgressionTableMetric && ['revenue', 'nfi', 'ebitda', 'net_profit'].includes(selectedProgressionTableMetric.key)
      ? { width: 'min(680px, calc(100vw - 24px))', 'max-width': 'calc(100vw - 24px)' }
      : selectedProgressionTableMetric?.key === 'cost_of_sales'
        ? { width: 'min(800px, calc(100vw - 24px))', 'max-width': 'calc(100vw - 24px)' }
        : { width: 'min(960px, calc(100vw - 32px))', 'max-width': 'calc(100vw - 32px)' }"
    [breakpoints]="{ '960px': 'calc(100vw - 8px)' }"
    [contentStyle]="{
      height: 'auto',
      'max-height': 'calc(100dvh - 3rem)',
      overflow: selectedProgressionTableMetric?.key === 'revenue' ? 'visible' : 'auto'
    }"
    [draggable]="false"
    [resizable]="false"
  >
    @if (selectedProgressionTableMetric) {
      <div class="relative flex min-h-full flex-col gap-3">
        <button type="button" class="table-dialog-close-button absolute right-2 top-2 z-20 grid h-6 w-6 place-items-center rounded-full text-[10px] shadow-sm transition" aria-label="Close" (click)="closeProgressionMetricTableDialog()">
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
        @if (comparisonPeriodLabel) {
          <div class="self-start rounded-md border border-primary/30 bg-primary-bg px-2 py-1 text-[10px] font-extrabold uppercase tracking-wide text-primary">
            {{ selectedProgressionPeriod === 'comparison' ? 'Comparison period' : 'Current period' }}
          </div>
        }
        @if (selectedProgressionTableMetric.key === 'cost_of_sales' && selectedProgressionKpiCard) {
          <div class="grid grid-cols-1 gap-2 sm:grid-cols-2 xl:grid-cols-5">
            <div class="rounded-lg border border-negative/25 bg-card px-3 py-2 shadow-sm">
              <div class="text-[9px] font-bold uppercase tracking-wide text-dim">Total Cost of Sales</div>
              <div class="mt-1 text-sm font-extrabold text-ink">{{ selectedProgressionKpiCard.value }}</div>
            </div>
            @for (detail of selectedProgressionKpiCard.details ?? []; track detail.label) {
              <div class="rounded-lg border border-negative/25 bg-card px-3 py-2 shadow-sm">
                <div class="text-[9px] font-bold uppercase tracking-wide text-dim">{{ detail.label }}</div>
                <div class="mt-1 truncate text-sm font-extrabold text-ink" [title]="detail.value">{{ detail.value }}</div>
              </div>
            }
          </div>
        }

        @if (selectedWeeklyFinancialMonth) {
          <div class="flex items-center gap-2">
            <button type="button" class="inline-flex h-7 items-center gap-1.5 rounded-md border border-line bg-card px-2.5 text-[11px] font-semibold text-dim hover:text-ink" (click)="showWeeklyFinancialMonthlySummary()">
              <i class="pi pi-arrow-left text-[10px]" aria-hidden="true"></i>
              Months
            </button>
            <span class="text-xs font-bold text-ink">{{ selectedWeeklyFinancialMonth }} weekly details</span>
          </div>
        }

        <div class="min-h-0 flex-1 overflow-hidden rounded-xl border border-line bg-card">
          <app-data-table
            [columns]="progressionTableColumns"
            [rows]="filteredProgressionTableRows"
            [grandTotalValues]="progressionGrandTotalValues"
            [showExport]="true"
            [showZeroBalanceToggle]="selectedProgressionTableMetric.key === 'operating_cost'"
            zeroBalanceField="totalAmount"
            [summaryValue]="selectedProgressionTableMetric.key === 'cost_of_sales' ? null : selectedProgressionKpiCard?.value ?? null"
            [summaryLabel]="selectedProgressionTableMetric.name"
            [exportFileName]="selectedProgressionTableMetric.name + ' table'"
            [filterFields]="[]"
            [showPaginator]="selectedProgressionTableMetric.key === 'cost_of_sales'"
            [pageSize]="10"
            [maxVisibleRows]="10"
            [reserveEmptyRows]="false"
            [showPageSizeSelector]="selectedProgressionTableMetric.key === 'cost_of_sales'"
            [showAllPageSizeOption]="selectedProgressionTableMetric.key === 'cost_of_sales'"
            [compact]="true"
            highlightedRowField="highlighted"
            [fitColumns]="selectedProgressionTableMetric.key === 'cost_of_sales'
              || ['revenue', 'nfi', 'ebitda', 'net_profit'].includes(selectedProgressionTableMetric.key)"
            [sortableFields]="selectedProgressionTableMetric.key === 'cost_of_sales'
              ? ['monthLabel']
              : ['nfi', 'ebitda', 'net_profit'].includes(selectedProgressionTableMetric.key)
                ? (selectedWeeklyFinancialMonth ? ['weekLabel'] : ['monthLabel'])
                : []"
            rowActionEnabledField="drillable"
            [showRowActions]="['revenue', 'operating_cost'].includes(selectedProgressionTableMetric.key)
              || (['nfi', 'ebitda', 'net_profit'].includes(selectedProgressionTableMetric.key) && !selectedWeeklyFinancialMonth)"
            (rowClick)="openProgressionTableRow($event)"
            recordName="Metric records"
          >
            <ng-template #filtersTemplate>
              @if (showProgressionMonthFilter) {
                <span class="text-[10px] font-bold uppercase tracking-wide text-muted">Month</span>
                <p-datepicker
                  [(ngModel)]="progressionTableMonthFilter"
                  view="month"
                  dateFormat="MM yy"
                  [readonlyInput]="true"
                  [showIcon]="true"
                  iconDisplay="input"
                  icon="pi pi-calendar"
                  appendTo="body"
                  class="w-40 shrink-0"
                  [style]="{ width: '160px' }"
                  inputStyleClass="h-7 w-40 rounded-md border border-line bg-page py-0 pl-2 pr-7 text-[11px] font-semibold text-ink outline-none focus:border-primary cursor-pointer"
                  ariaLabel="Filter progression table by month"
                />
                @if (progressionTableMonthFilter) {
                  <button type="button" class="flex h-7 w-7 items-center justify-center rounded-md border border-line bg-card text-muted hover:text-ink" (click)="progressionTableMonthFilter = null" aria-label="Clear month filter" title="Clear month filter">
                    <i class="pi pi-times text-[10px]"></i>
                  </button>
                }
              }
            </ng-template>
          </app-data-table>
        </div>
      </div>
    }
  </p-dialog>

  <p-dialog
    [visible]="selectedFinancialProgressionMonth !== null"
    appendTo="body"
    (visibleChange)="!$event && closeFinancialDailyDetailDialog()"
    [modal]="true"
    [showHeader]="false"
    styleClass="table-dialog--headerless"
    transitionOptions="0ms"
    [style]="{ width: 'min(680px, calc(100vw - 24px))', 'max-width': 'calc(100vw - 24px)' }"
    [breakpoints]="{ '960px': 'calc(100vw - 16px)' }"
    [contentStyle]="{ height: 'auto', 'max-height': 'calc(100dvh - 3rem)', overflow: 'auto' }"
    [header]="tableDialogHeader(
      selectedProgressionTableMetric ? selectedProgressionTableMetric.name + ' Daily Details' : 'Financial Daily Details',
      selectedFinancialProgressionMonth
    )"
    [draggable]="false"
    [resizable]="false"
  >
    <div class="relative flex min-h-full flex-col gap-3">
      <button type="button" class="table-dialog-close-button absolute right-2 top-2 z-20 grid h-6 w-6 place-items-center rounded-full text-[10px] shadow-sm transition" aria-label="Close" (click)="closeFinancialDailyDetailDialog()">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
      <div class="min-h-0 flex-1 overflow-auto rounded-xl border border-line bg-card">
        <app-data-table
          [columns]="financialDailyDetailColumns"
          [rows]="selectedFinancialDailyDetailRows"
          [showExport]="true"
          [summaryValue]="selectedFinancialMonthKpiCard?.value ?? null"
          [summaryLabel]="selectedProgressionTableMetric?.name ?? null"
          [exportFileName]="selectedProgressionTableMetric && selectedFinancialProgressionMonth
            ? selectedProgressionTableMetric.name + ' Daily Details - ' + selectedFinancialProgressionMonth
            : 'Financial Daily Details'"
          [filterFields]="['date']"
          [showPaginator]="true"
          [pageSize]="10"
          [showPageSizeSelector]="true"
          [showAllPageSizeOption]="true"
          [maxVisibleRows]="7"
          [compact]="true"
          [sortableFields]="['date']"
          recordName="Financial daily detail records"
        />
      </div>
    </div>
  </p-dialog>

  <p-dialog
    [visible]="selectedAdministrativeCost !== null"
    appendTo="body"
    (visibleChange)="!$event && closeAdministrativeCostDetailDialog()"
    [modal]="true"
    [showHeader]="false"
    styleClass="table-dialog--headerless"
    transitionOptions="0ms"
    [style]="{ width: 'min(1100px, calc(100vw - 24px))', 'max-width': 'calc(100vw - 24px)' }"
    [breakpoints]="{ '960px': 'calc(100vw - 16px)' }"
    [contentStyle]="{ height: 'auto', 'max-height': 'calc(100dvh - 3rem)', overflow: 'auto' }"
    [header]="tableDialogHeader(selectedAdministrativeCost ? selectedAdministrativeCost.administrativeCostName + ' Details' : 'Administrative Cost Details')"
    [draggable]="false"
    [resizable]="false"
  >
    <div class="relative flex min-h-full flex-col gap-3">
      <button type="button" class="table-dialog-close-button absolute right-2 top-2 z-20 grid h-6 w-6 place-items-center rounded-full text-[10px] shadow-sm transition" aria-label="Close" (click)="closeAdministrativeCostDetailDialog()">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
      <div class="min-h-0 flex-1 overflow-auto rounded-xl border border-line bg-card">
        <app-data-table
          [columns]="administrativeCostDetailColumns"
          [rows]="selectedAdministrativeCostDetailRows"
          [showExport]="true"
          [summaryValue]="selectedAdministrativeCostKpiCard?.value ?? null"
          [summaryLabel]="selectedAdministrativeCost?.administrativeCostName ?? null"
          [exportFileName]="selectedAdministrativeCost ? selectedAdministrativeCost.administrativeCostName + ' Details' : 'Administrative Cost Details'"
          [filterFields]="['date', 'source', 'description', 'reference']"
          [showPaginator]="true"
          [pageSize]="10"
          [showPageSizeSelector]="true"
          [showAllPageSizeOption]="true"
          [maxVisibleRows]="7"
          [compact]="true"
          [fitColumns]="true"
          [sortableFields]="['date']"
          recordName="Administrative cost detail records"
        />
      </div>
    </div>
  </p-dialog>

  <p-dialog
    [visible]="selectedConsultant !== null"
    appendTo="body"
    (visibleChange)="!$event && closeConsultantDialog()"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: 'min(1000px, calc(100vw - 32px))' }"
    [contentStyle]="{ maxHeight: 'calc(100dvh - 8rem)', overflow: 'auto' }"
    [header]="tableDialogHeader(selectedConsultant ? selectedConsultant.consultant : 'Consultant details')"
  >
    @if (selectedConsultant) {
      <div>
        <div class="w-full overflow-hidden rounded-xl border border-line bg-card">
          <app-data-table
            [columns]="consultantMonthlyColumns"
            [rows]="selectedConsultantMonthlyRows"
            [showPaginator]="false"
            [pageSize]="selectedConsultantMonthlyRows.length || 1"
            [maxVisibleRows]="selectedConsultantMonthlyRows.length > 7 ? 7 : (selectedConsultantMonthlyRows.length || 1)"
            [compact]="true"
            [showExport]="true"
            [summaryItems]="selectedConsultantSummaryItems"
            [exportFileName]="selectedConsultant.consultant + ' monthly performance'"
            [sortableFields]="[]"
            recordName="Monthly records"
            (rowClick)="openConsultantMonthDialog($event)"
          />
        </div>
      </div>
    }
  </p-dialog>

  <p-dialog
    [visible]="selectedConsultantMonth !== null"
    (visibleChange)="!$event && closeConsultantMonthDialog()"
    [modal]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '98vw', maxWidth: '1800px' }"
    [header]="tableDialogHeader(
      selectedConsultantMonth ? selectedConsultantMonth.consultant + ' Monthly stats' : 'Monthly consultant stats',
      selectedConsultantMonth?.monthLabel
    )"
  >
    @if (selectedConsultantMonth) {
      <div class="overflow-hidden rounded-xl border border-line bg-card">
        <app-data-table
          [columns]="consultantInvoiceTimesheetColumns"
          [rows]="selectedConsultantInvoiceTimesheetRows"
          [showPaginator]="selectedConsultantInvoiceTimesheetRows.length > 50"
          [pageSize]="50"
          [maxVisibleRows]="selectedConsultantInvoiceTimesheetRows.length > 7 ? 7 : (selectedConsultantInvoiceTimesheetRows.length || 1)"
          [pageSizeOptions]="[50, 100, 150]"
          [showPageSizeSelector]="true"
          [showAllPageSizeOption]="true"
          [showExport]="true"
          [summaryItems]="selectedConsultantMonthSummaryItems"
          [showColumnSelector]="true"
          [columnsReorderable]="true"
          [filterFields]="['invoiceDate', 'invoiceNumber', 'invoiceDescription', 'candidateName', 'timesheetId', 'isExpense', 'clientName', 'placementId', 'contractType', 'jobTitle']"
          [exportFileName]="selectedConsultantMonth.consultant + ' ' + selectedConsultantMonth.monthLabel + ' invoice timesheet details'"
          [sortableFields]="[]"
          recordName="Invoice timesheet records"
        />
      </div>
    }
  </p-dialog>

  <p-dialog
    [visible]="selectedTurnoverSalesType !== null"
    appendTo="body"
    (visibleChange)="!$event && closeTurnoverDetailDialog()"
    [modal]="true"
    [showHeader]="false"
    styleClass="table-dialog--headerless"
    transitionOptions="0ms"
    [style]="{ width: 'min(680px, calc(100vw - 24px))', 'max-width': 'calc(100vw - 24px)' }"
    [breakpoints]="{ '640px': 'calc(100vw - 16px)' }"
    [contentStyle]="{ height: 'auto', 'max-height': 'min(720px, calc(100dvh - 3rem))', overflow: 'auto' }"
    [header]="tableDialogHeader((selectedTurnoverMetricName ?? 'Revenue') + ' Details')"
    [draggable]="false"
    [resizable]="false"
  >
    <div class="relative flex min-h-full flex-col gap-3">
      <button type="button" class="table-dialog-close-button absolute right-2 top-2 z-20 grid h-6 w-6 place-items-center rounded-full text-[10px] shadow-sm transition" aria-label="Close" (click)="closeTurnoverDetailDialog()">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
      @if (selectedTurnoverKpiCard) {
        <div class="grid grid-cols-1 gap-2 sm:grid-cols-3">
          <div class="rounded-lg border border-primary/25 bg-card px-3 py-2 shadow-sm">
            <div class="text-[9px] font-bold uppercase tracking-wide text-dim">{{ selectedTurnoverKpiCard.label }}</div>
            <div class="mt-1 text-sm font-extrabold text-ink">{{ selectedTurnoverKpiCard.value }}</div>
          </div>
          @for (detail of selectedTurnoverKpiCard.details ?? []; track detail.label) {
            <div class="rounded-lg border border-primary/25 bg-card px-3 py-2 shadow-sm">
              <div class="text-[9px] font-bold uppercase tracking-wide text-dim">{{ detail.label }}</div>
              <div class="mt-1 text-sm font-extrabold text-ink">{{ detail.value }}</div>
            </div>
          }
        </div>
      }

      @if (selectedTurnoverMonth) {
        <div class="flex items-center gap-2">
          <button type="button" class="inline-flex h-7 items-center gap-1.5 rounded-md border border-line bg-card px-2.5 text-[11px] font-semibold text-dim hover:text-ink" (click)="showTurnoverMonthlySummary()">
            <i class="pi pi-arrow-left text-[10px]" aria-hidden="true"></i>
            Months
          </button>
          <span class="text-xs font-bold text-ink">{{ selectedTurnoverMonth }} weekly details</span>
        </div>
      }

    <div class="min-h-0 flex-1 overflow-auto rounded-xl border border-line bg-card">
      <app-data-table
        [columns]="turnoverDetailColumns"
        [rows]="filteredSelectedTurnoverDetailRows"
        [grandTotalValues]="selectedTurnoverGrandTotalValues"
        [showExport]="true"
        [exportFileName]="(selectedTurnoverMetricName ?? 'Revenue') + ' Details'"
        [filterFields]="[]"
        [showPaginator]="true"
        [pageSize]="10"
        [showPageSizeSelector]="true"
        [showAllPageSizeOption]="true"
        [maxVisibleRows]="7"
        [reserveEmptyRows]="false"
        [compact]="true"
        [fitColumns]="true"
        [sortableFields]="selectedTurnoverMonth ? ['monthLabel', 'weekLabel'] : ['monthLabel']"
        rowActionEnabledField="drillable"
        [showRowActions]="!selectedTurnoverMonth"
        (rowClick)="openTurnoverDetailRow($event)"
        [recordName]="selectedTurnoverMonth ? 'Weekly turnover records' : 'Monthly turnover records'"
      >
        <ng-template #filtersTemplate>
          @if (!selectedTurnoverMonth) {
          <span class="text-[10px] font-bold uppercase tracking-wide text-muted">Month</span>
          <p-datepicker
            [(ngModel)]="turnoverTableMonthFilter"
            view="month"
            dateFormat="MM yy"
            [readonlyInput]="true"
            [showIcon]="true"
            iconDisplay="input"
            icon="pi pi-calendar"
            appendTo="body"
            class="w-40 shrink-0"
            [style]="{ width: '160px' }"
            inputStyleClass="h-7 w-40 rounded-md border border-line bg-page py-0 pl-2 pr-7 text-[11px] font-semibold text-ink outline-none focus:border-primary cursor-pointer"
            ariaLabel="Filter turnover details by month"
          />
          @if (turnoverTableMonthFilter) {
            <button type="button" class="flex h-7 w-7 items-center justify-center rounded-md border border-line bg-card text-muted hover:text-ink" (click)="turnoverTableMonthFilter = null" aria-label="Clear month filter" title="Clear month filter">
              <i class="pi pi-times text-[10px]"></i>
            </button>
          }
          }
        </ng-template>
      </app-data-table>
    </div>
    </div>
  </p-dialog>

  <p-dialog
    [visible]="agedDebtTableVisible"
    (visibleChange)="!$event && closeAgedDebtTableDialog()"
    [modal]="true"
    transitionOptions="0ms"
    [style]="{ width: 'min(1120px, calc(100vw - 32px))', 'max-width': 'calc(100vw - 32px)' }"
    [breakpoints]="{ '960px': 'calc(100vw - 24px)' }"
    [contentStyle]="{ height: 'auto', 'max-height': 'calc(100dvh - 6rem)', overflow: 'auto' }"
    [header]="tableDialogHeader('Aged Debt Buckets table')"
    [draggable]="false"
    [resizable]="false"
  >
    <div class="flex min-h-full flex-col">
      <div class="min-h-0 flex-1 overflow-hidden rounded-xl border border-line bg-card">
        <app-data-table
          [columns]="agedDebtTableColumns"
          [rows]="filteredAgedDebtBucketSummaryView"
          [showExport]="true"
          exportFileName="Aged Debt Buckets table"
          [showPaginator]="false"
          [compact]="true"
          [sortableFields]="['monthLabel']"
          recordName="Aged debt records"
          (rowClick)="openAgedDebtMonthDetails($event)"
        >
          <ng-template #filtersTemplate>
            <span class="text-[10px] font-bold uppercase tracking-wide text-muted">Month</span>
            <p-datepicker
              [(ngModel)]="selectedAgedDebtTableMonth"
              view="month"
              dateFormat="MM yy"
              [readonlyInput]="true"
              [showIcon]="true"
              iconDisplay="input"
              icon="pi pi-calendar"
              appendTo="body"
              class="w-40 shrink-0"
              [style]="{ width: '160px' }"
              inputStyleClass="h-7 w-40 rounded-md border border-line bg-page py-0 pl-2 pr-7 text-[11px] font-semibold text-ink outline-none focus:border-primary cursor-pointer"
              ariaLabel="Filter aged debt table by month"
            />
            @if (selectedAgedDebtTableMonth) {
              <button type="button" class="flex h-7 w-7 items-center justify-center rounded-md border border-line bg-card text-muted hover:text-ink" (click)="selectedAgedDebtTableMonth = null" aria-label="Clear month filter" title="Clear month filter">
                <i class="pi pi-times text-[10px]"></i>
              </button>
            }
          </ng-template>
        </app-data-table>
      </div>
    </div>
  </p-dialog>

  <p-dialog
    [visible]="selectedAgedDebtSummaryMonth !== null"
    appendTo="body"
    (visibleChange)="!$event && closeAgedDebtMonthDetails()"
    [modal]="true"
    transitionOptions="0ms"
    [style]="{ width: 'min(1380px, calc(100vw - 32px))', 'max-width': 'calc(100vw - 32px)' }"
    [breakpoints]="{ '960px': 'calc(100vw - 24px)' }"
    [contentStyle]="{ height: 'min(680px, calc(100dvh - 8rem))', overflow: 'auto' }"
    [header]="tableDialogHeader('Aged Debt Details', selectedAgedDebtSummaryMonth)"
    [draggable]="false"
    [resizable]="false"
  >
    <div class="min-h-0 overflow-auto rounded-xl border border-line bg-card">
      <app-data-table
        [columns]="agedDebtDetailTableColumns"
        [rows]="selectedAgedDebtMonthDetailRows"
        [showExport]="true"
        [exportFileName]="selectedAgedDebtSummaryMonth ? 'Aged Debt Details - ' + selectedAgedDebtSummaryMonth : 'Aged Debt Details'"
        [filterFields]="['invoiceNumber', 'invoiceDate', 'dueDate']"
        [showPaginator]="true"
        [showPageSizeSelector]="true"
        [showAllPageSizeOption]="true"
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50]"
        [maxVisibleRows]="10"
        [compact]="true"
        [sortableFields]="['invoiceNumber', 'agedBucket', 'clientName', 'invoiceDate', 'dueDate', 'invoiceTotal', 'outstandingAtMonthEnd', 'daysOverdue']"
        recordName="Aged debt invoice records"
      />
    </div>
  </p-dialog>

  <p-dialog
    [visible]="selectedKpiTable !== null"
    (visibleChange)="!$event && closeKpiTableDialog()"
    [modal]="true"
    [showHeader]="false"
    styleClass="table-dialog--headerless"
    transitionOptions="0ms"
    [style]="{ width: kpiTableDialogWidth, 'max-width': 'calc(100vw - 32px)' }"
    [breakpoints]="{ '960px': 'calc(100vw - 24px)' }"
    [contentStyle]="useCompactKpiTableDialog
      ? { height: 'auto', 'max-height': 'calc(100dvh - 8rem)', overflow: 'auto' }
      : { height: 'min(680px, calc(100dvh - 8rem))', overflow: 'auto' }"
    [header]="tableDialogHeader(
      selectedKpiTable ? selectedKpiTable.label + ' table' : 'KPI table',
      selectedKpiTable?.key === 'contractors_worked'
        ? selectedContractorsWorkedMonth
        : selectedKpiTable?.key === 'cash_collected_pct'
          ? selectedCashCollectedMonth
          : null
    )"
    [draggable]="false"
    [resizable]="false"
  >
    @if (selectedKpiTable) {
      <div class="relative flex min-h-full flex-col gap-3">
        <button type="button" class="table-dialog-close-button absolute right-2 top-2 z-20 grid h-6 w-6 place-items-center rounded-full text-[10px] shadow-sm transition" aria-label="Close" (click)="closeKpiTableDialog()">
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
        @if (hasKpiTableComparison) {
          <div class="flex flex-wrap items-center gap-2 pr-10">
            <div class="inline-flex overflow-hidden rounded-md border border-line bg-page p-0.5" role="group" aria-label="Choose KPI table period">
              <button
                type="button"
                class="rounded px-3 py-1.5 text-[11px] font-semibold transition-colors"
                [class.bg-primary]="selectedKpiTablePeriod === 'current'"
                [class.text-white]="selectedKpiTablePeriod === 'current'"
                [class.text-dim]="selectedKpiTablePeriod !== 'current'"
                [class.hover:bg-primary-bg]="selectedKpiTablePeriod !== 'current'"
                (click)="setKpiTablePeriod('current')"
              >Current Period</button>
              <button
                type="button"
                class="rounded px-3 py-1.5 text-[11px] font-semibold transition-colors"
                [class.bg-primary]="selectedKpiTablePeriod === 'comparison'"
                [class.text-white]="selectedKpiTablePeriod === 'comparison'"
                [class.text-dim]="selectedKpiTablePeriod !== 'comparison'"
                [class.hover:bg-primary-bg]="selectedKpiTablePeriod !== 'comparison'"
                (click)="setKpiTablePeriod('comparison')"
              >Comparison Period</button>
            </div>
            @if (selectedKpiTablePeriodLabel) {
              <span class="text-[11px] font-semibold text-dim">{{ selectedKpiTablePeriodLabel }}</span>
            }
          </div>
        }
        @if (selectedCashCollectedMonth) {
          <div class="flex items-center gap-2 pr-10">
            <button type="button" class="inline-flex h-7 items-center gap-1.5 rounded-md border border-line bg-card px-2.5 text-[11px] font-semibold text-dim hover:text-ink" (click)="showCashCollectedMonths()">
              <i class="pi pi-arrow-left text-[10px]" aria-hidden="true"></i>
              Months
            </button>
            <span class="text-xs font-bold text-ink">{{ selectedCashCollectedMonth }} cash collected breakdown</span>
          </div>
        }
        <div class="min-h-0 flex-1 overflow-hidden rounded-xl border border-line bg-card">
          <app-data-table
            [columns]="kpiTableColumns"
            [rows]="kpiTableRows"
            [showExport]="true"
            [summaryValue]="kpiTableSummaryValue"
            [summaryLabel]="kpiTableSummaryLabel"
            [exportFileName]="selectedKpiTable.label + (selectedCashCollectedMonth ? ' ' + selectedCashCollectedMonth : '') + ' table'"
            [showPaginator]="!!selectedCashCollectedMonth"
            [showPageSizeSelector]="!!selectedCashCollectedMonth"
            [showAllPageSizeOption]="!!selectedCashCollectedMonth"
            [pageSize]="selectedKpiTable.key === 'contractors_worked' ? 11 : 10"
            [maxVisibleRows]="selectedKpiTable.key === 'contractors_worked' ? 11 : 10"
            [compact]="true"
            [fitColumns]="useCompactKpiTableDialog || selectedKpiTable.key === 'contractors_worked'"
            [filterFields]="selectedKpiTable.key === 'contractors_worked' ? ['candidateName'] : selectedCashCollectedMonth ? ['client', 'documentNumber', 'reference'] : []"
            [searchPlaceholder]="selectedKpiTable.key === 'contractors_worked' ? 'Filter by candidate name...' : selectedCashCollectedMonth ? 'Filter by client, invoice or reference...' : 'Search...'"
            [sortableFields]="selectedCashCollectedMonth ? ['date', 'source', 'client', 'amount'] : ['monthLabel']"
            rowActionEnabledField="drillable"
            [showRowActions]="showCashCollectedMonthActions"
            (rowClick)="openCashCollectedMonth($event)"
            [recordName]="selectedCashCollectedMonth ? 'Cash collected entries' : 'KPI records'"
          />
        </div>
      </div>
    }
  </p-dialog>

  <p-dialog
    [visible]="overviewDetailIndex !== null"
    (visibleChange)="!$event && closeOverviewDetail()"
    [modal]="true"
    transitionOptions="0ms"
    [style]="{ width: 'min(1180px, calc(100vw - 32px))', 'max-width': 'calc(100vw - 32px)' }"
    [breakpoints]="{ '960px': 'calc(100vw - 24px)' }"
    [contentStyle]="{ height: 'min(760px, calc(100dvh - 8rem))', overflow: 'hidden' }"
    [header]="tableDialogHeader(overviewDetailPeriod === 'comparison' ? 'Comparison period chart data' : 'Current period chart data')"
    [draggable]="false"
    [resizable]="false"
  >
    @if (overviewDetailIndex !== null && overviewDetailData) {
      <app-overview-table-detail
        [data]="overviewDetailData"
        [drillData]="overviewDetailDrillData"
        [metric]="activeChart1Metric"
        [period]="overviewDetailPeriod"
        [selectedIndex]="overviewDetailIndex"
        (selectedIndexChange)="overviewDetailIndex = $event"
      />
    }
  </p-dialog>

  @if (contextMenu) {
  <div class="fixed z-[80] min-w-[180px] overflow-hidden rounded-[8px] border border-line bg-card shadow-xl"
    [style.left.px]="contextMenu.x" [style.top.px]="contextMenu.y" (click)="$event.stopPropagation()">
    <button type="button"
      class="block w-full px-3 py-2 text-left text-xs font-medium text-ink hover:bg-primary-bg disabled:cursor-not-allowed disabled:opacity-40"
      [disabled]="contextDisabled('drillDown')" (click)="runContextAction('drillDown')">Drill down</button>
    <button type="button"
      class="block w-full px-3 py-2 text-left text-xs font-medium text-ink hover:bg-primary-bg disabled:cursor-not-allowed disabled:opacity-40"
      [disabled]="contextDisabled('drillUp')" (click)="runContextAction('drillUp')">Drill up</button>
    <button type="button"
      class="block w-full px-3 py-2 text-left text-xs font-medium text-ink hover:bg-primary-bg disabled:cursor-not-allowed disabled:opacity-40"
      [disabled]="contextDisabled('keepOnly')" (click)="runContextAction('keepOnly')">Keep only this</button>
    <button type="button"
      class="block w-full px-3 py-2 text-left text-xs font-medium text-ink hover:bg-primary-bg disabled:cursor-not-allowed disabled:opacity-40"
      [disabled]="contextDisabled('clearFilter')" (click)="runContextAction('clearFilter')">Clear this filter</button>
    <button type="button"
      class="block w-full px-3 py-2 text-left text-xs font-medium text-ink hover:bg-primary-bg disabled:cursor-not-allowed disabled:opacity-40"
      [disabled]="contextDisabled('viewRecords')" (click)="runContextAction('viewRecords')">View records / Show
      data</button>
    <button type="button"
      class="block w-full px-3 py-2 text-left text-xs font-medium text-ink hover:bg-primary-bg disabled:cursor-not-allowed disabled:opacity-40"
      [disabled]="contextDisabled('copyValue')" (click)="runContextAction('copyValue')">Copy value</button>
  </div>
  }

  @if (overviewMonthContextMenu) {
  <div
    class="fixed z-[80] min-w-[140px] overflow-hidden rounded-[8px] border border-line bg-card shadow-xl"
    [style.left.px]="overviewMonthContextMenu.x"
    [style.top.px]="overviewMonthContextMenu.y"
    (click)="$event.stopPropagation()"
  >
    <button
      type="button"
      class="block w-full px-3 py-2 text-left text-xs font-medium text-ink hover:bg-primary-bg"
      (click)="showOverviewMonthAsTable()"
    >
      Show as table
    </button>
  </div>
  }

</div>
